import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from "@angular/forms";

export class FormHelper {

    static showInvalidFormFields(formGroup: UntypedFormGroup | UntypedFormArray) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof UntypedFormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof UntypedFormGroup) {
                this.showInvalidFormFields(control);
            } else if (control instanceof UntypedFormArray) {
                control.markAsTouched();
                this.showInvalidFormFields(control);
            }
        });
    }
}
